import React from "react";

interface SubtitlesFilledIconProps {
  className?: string;
}

const SubtitlesFilledIcon: React.FC<SubtitlesFilledIconProps> = ({ className }) => (
  <svg width="22px" height="22px" viewBox="0 0 350 350">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <g fill="#79B17D">
          <rect x="0" y="0" width="350" height="350" rx="45" />
        </g>
        <rect fill="#FFFFFF" x="53" y="201" width="73" height="31.3902439" rx="15.695122" />
        <rect fill="#FFFFFF" x="225" y="263.609756" width="73" height="31.3902439" rx="15.695122" />
        <rect fill="#FFFFFF" x="156" y="201" width="142" height="31.3902439" rx="15.695122" />
        <rect fill="#FFFFFF" x="53" y="263.609756" width="142" height="31.3902439" rx="15.695122" />
      </g>
    </g>
  </svg>
);

export default SubtitlesFilledIcon;
